<script setup lang="ts">
import { computed } from "vue"
import UploadSingleEditPanel from "./UploadSingleEditPanel.vue"
import UploadBatchEditPanel from "./UploadBatchEditPanel.vue"
import { useUploadEditSessionContext } from "./UploadEditSessionKey"
import type { MediaFormData } from "../media/media"

interface Candidate {
  id: string
  filename: string
  draft: MediaFormData
}

const props = defineProps<{
  candidates: Candidate[]
  previewUrls: Record<string, string | undefined>
}>()

const session = useUploadEditSessionContext()

const activePreview = computed<string | undefined>(() =>
  session.activeId.value ? props.previewUrls[session.activeId.value] : undefined
)

const otherCandidates = computed<Candidate[]>(() =>
  props.candidates.filter(c => c.id !== session.activeId.value)
)

function onBatchApplied(): void {
  session.selectedIds.value = new Set()
  session.activeId.value = null
}

function onBatchCancel(): void {
  session.selectedIds.value = new Set()
  session.activeId.value = null
}
</script>

<template>
  <div class="h-full w-full min-w-0">
    <div v-if="session.mode.value === 'empty'" data-testid="pane-empty" class="h-full flex items-center justify-center text-gray-500">
      Wähle eine Datei aus der Liste.
    </div>
    <UploadSingleEditPanel
      v-else-if="session.mode.value === 'single'"
      :preview-url="activePreview"
      :other-candidates="otherCandidates"
    />
    <UploadBatchEditPanel
      v-else
      @applied="onBatchApplied"
      @cancel="onBatchCancel"
    />
  </div>
</template>
